export const CoaImportHeaders = {
	AccountNumber: 'AccountNumber',
	Description: 'Description',
	AccountType: 'AccountType',
	StartDate: 'StartDate',
	EndDate: 'EndDate',
	BeginningBalance: 'BeginningBalance',
};
